import PropTypes from 'prop-types';
import React from 'react';
import { formatDateTime } from '../../../library/utils/intl.js';
import DocumentsDownloader from '../../../routes/template/documentDownloader.jsx';
import SmallSection from '../../design/small-section.jsx';

const ORDER_DOCUMENT_TYPES = {
    vendor_template: "Template Sent",
    order_artwork_to_vendor: "Artwork Recieved",
    vendor_proof: "Proof Sent",
    confirm_proof_by_client: "Confirmed Proof",
    order_uploaded_proof_of_delivery_for_files: "Delivery Proof by Leoprinting",
    client_uploaded_address: "Bulk Delivery Addresses",
    dispatched_date_file: "Bulk Delivery Dispatch Dates",
    add_shipping_details_file: "Bulk Delivery Shipping Details",
    shipping_details_file_confirm_by_order: "Bulk Delivery Proofs by Leoprinting",
    supplier_files: "Files Recieved",
    supplier_delivery_proof: "Delivery Proof by Leoprinting",
    supplier_delivery_proof_via_vendor: "Delivery Proof uploaded",
    vendor_purchase_order: "Purchase Order",
    supplier_purchase_order: "Purchase Order",
    vendor_delivery_notes: "Delivery Note",
    supplier_delivery_notes: "Delivery Note",
}

const FilePropType = PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    comment: PropTypes.string,
    uploaded_by: PropTypes.string,
    uploaded_time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
})

const OrderDocumentSection = ({ projectId, title, files, itemId, dateTime, comment }) => {
    if (!files || files.length === 0) {
        return <></>
    }
    return (
        <SmallSection header={(<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>{title}</h3>
            <span style={{ color: '#3a3a3a' }}>{formatDateTime(dateTime)}</span>
        </div>)}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                {files && files.filter(file => !!file.url).map(file => (
                    <DocumentsDownloader key={file.url} image={file?.url} name={file?.name} comment={file?.comment} project_id={projectId} itemId={itemId} />
                ))}
            </div>
            {comment?.length > 0 && (
                <>
                    < hr />
                    <strong>Comment:</strong> <i>{comment}</i>
                </>
            )}
        </SmallSection>
    )
}
OrderDocumentSection.propTypes = {
    projectId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    itemId: PropTypes.number.isRequired,
    files: PropTypes.arrayOf(FilePropType),
    dateTime: PropTypes.string,
    comment: PropTypes.string,
}

const OrderDocuments = ({ projectId, documents, itemId }) => {
    return (
        <>
            {!!documents.supplier_files && documents.supplier_files.length > 0 &&
                <OrderDocumentSection title='Files Sent to Vendor' projectId={projectId} itemId={itemId} files={documents.supplier_files} />}
            <OrderDocumentSection title='Vendor template' projectId={projectId} itemId={itemId} files={documents.vendor_template} />
            <OrderDocumentSection title='Artwork Recieved from Leoprinting' projectId={projectId} itemId={itemId} files={documents.order_artwork_to_vendor} />
            <OrderDocumentSection title='Proof Sent to Leopriting' projectId={projectId} itemId={itemId} files={documents.vendor_proof} />
        </>
    )
}

OrderDocuments.propTypes = {
    projectId: PropTypes.number.isRequired,
    itemId: PropTypes.number.isRequired,
    documents: PropTypes.shape({
        supplier_files: PropTypes.arrayOf(FilePropType),
        vendor_template: PropTypes.arrayOf(FilePropType),
        order_template_to_studio: PropTypes.arrayOf(FilePropType),
        studio_template: PropTypes.arrayOf(FilePropType),
        order_template_to_client: PropTypes.arrayOf(FilePropType),
        make_artwork_send_to_studio: PropTypes.arrayOf(FilePropType),
        make_artwork_from_studio: PropTypes.arrayOf(FilePropType),
        make_artwork_send_to_client: PropTypes.arrayOf(FilePropType),
        client_artwork: PropTypes.arrayOf(FilePropType),
        order_artwork_to_studio: PropTypes.arrayOf(FilePropType),
        studio_artwork: PropTypes.arrayOf(FilePropType),
        order_artwork_to_vendor: PropTypes.arrayOf(FilePropType),
        vendor_proof: PropTypes.arrayOf(FilePropType),
        order_proof_to_studio: PropTypes.arrayOf(FilePropType),
        studio_proof: PropTypes.arrayOf(FilePropType),
        order_proof_to_client: PropTypes.arrayOf(FilePropType),
    })
}

const OrderDocumentsNew = ({ projectId, documents, itemId }) => {
    return documents?.filter(({ type }) => !!ORDER_DOCUMENT_TYPES[type])?.map(({ id, documents: files, type, comments, updatedAt }) => <OrderDocumentSection key={id} projectId={projectId} itemId={itemId} title={ORDER_DOCUMENT_TYPES[type]} files={files} dateTime={updatedAt} comment={comments} />)
}
OrderDocumentsNew.propTypes = {
    projectId: PropTypes.number.isRequired,
    itemId: PropTypes.number.isRequired,
    finisherTimelineVisible: PropTypes.bool,
    documents: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        documents: PropTypes.arrayOf(FilePropType).isRequired,
        updatedAt: PropTypes.string,
        type: PropTypes.string,
    })),
}

export { OrderDocuments, OrderDocumentsNew };
